import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import ReactRouterPropTypes from 'react-router-prop-types'
import { withRouter } from 'react-router-dom'
import { injectIntl } from 'react-intl'
import { isTablet, MobileView, BrowserView } from 'react-device-detect'
import useGetConfigurator from 'core/hooks/useGetConfigurator'
import * as routes from 'core/routing/constants/index'
import MainContentWrapper from 'core/templates/MainContentWrapper'
import wizardsShape from 'core/components/wizard/shapes'
import { Row, Col, Carousel, Empty, List } from 'core/components/ui'
import PageLoading from 'core/components/page-loading'
import { configuratorShape } from '../shapes'
import FinishesCard from './finishes-card'
import ListItem from './list-item'
import ModalEquipments from './modal-equipments'

const Finishes = props => {
  const { configurator, setConfigurator, intl, setWizards, wizards, history } = props

  const { loading, getTrims, trims } = useGetConfigurator({
    redirectMessage: intl.formatMessage({ id: 'ui-session-expired' })
  })
  const [id, setId] = useState(null)

  const { brand, model, finishes, finishesList } = configurator

  const desactivateNextStep = () => {
    const aStepsActive = wizards[wizards.activeWizard]

    const nextIndex = aStepsActive.findIndex(step => step.hash === routes.CONFIGURATOR_FINISHES) + 1

    const extendedStep = { ...aStepsActive[nextIndex], isActive: false }

    const extendedSteps = Object.assign([...aStepsActive], {
      [nextIndex]: extendedStep
    })

    const extentedWizards = { ...wizards, aStepsConfigurator: extendedSteps }
    setWizards(extentedWizards)
  }

  const handleClickShowEquipment = item => {
    setId(item)
  }

  const handleClickClose = () => {
    setId(null)
  }

  const renderList = () =>
    finishesList.map(item => (
      <Col data-test="configurator-finishes-Finishes-listItem">
        <FinishesCard
          key={item.id}
          item={item}
          handleClickShowEquipment={handleClickShowEquipment}
          data-test="configurator-finishes-Finishes-listItem-card"
        />
      </Col>
    ))

  useEffect(() => {
    const runIt = list => {
      setConfigurator({
        ...configurator,
        finishesList: list
        // motorsList: null,
        //  motor: null
      })
    }

    if (trims) runIt(trims)
  }, [trims])

  useEffect(() => {
    // Redirection if direct access & step is not active
    const aStepsActive = wizards[wizards.activeWizard]

    const extendedStepsActive = aStepsActive.filter(
      step => step.hash === routes.CONFIGURATOR_FINISHES
    )
    const currentStep = extendedStepsActive[0]

    const { isActive } = currentStep

    if (!isActive) {
      history.push(routes.HOME)
    }

    if (!finishes) desactivateNextStep()

    const params = {
      brand: brand.id,
      model: model.id
    }

    getTrims(params)
  }, [])

  const settings = {
    arrows: true,
    swipeToSlide: true,
    draggable: true,
    infinite: false,
    slidesToShow: 4,
    slidesToScroll: 4,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  }

  return (
    <MainContentWrapper
      title={intl.formatMessage({ id: 'configurator-finishes-view-title' })}
      data-test="component-configurator-finishes-Finishes"
    >
      {loading && !finishesList ? (
        <PageLoading data-test="configurator-finishes-Finishes-loading" />
      ) : (
        <>
          <Row gutter={8} data-test="configurator-finishes-Finishes-listWrapper">
            {finishesList ? (
              <>
                {!isTablet && (
                  <BrowserView>
                    <Carousel {...settings}>{renderList()}</Carousel>{' '}
                  </BrowserView>
                )}
                <MobileView>
                  <List
                    itemLayout="vertical"
                    dataSource={finishesList}
                    renderItem={item => (
                      <ListItem item={item} handleClickShowEquipment={handleClickShowEquipment} />
                    )}
                  />
                </MobileView>
              </>
            ) : (
              <Empty />
            )}
          </Row>
        </>
      )}
      <ModalEquipments id={id} handleClickClose={handleClickClose} />
    </MainContentWrapper>
  )
}

Finishes.propTypes = {
  history: ReactRouterPropTypes.history.isRequired,
  intl: PropTypes.shape().isRequired,
  setWizards: PropTypes.func.isRequired,
  wizards: wizardsShape.isRequired,
  setConfigurator: PropTypes.func.isRequired,
  configurator: configuratorShape.isRequired
}

export default withRouter(injectIntl(Finishes))
